export default "__VITE_ASSET__7tRnTPq4__"